import { db } from "../firebaseConfig";
import {
  collection,
  addDoc,
  getDocs,
  updateDoc,
  deleteDoc,
  doc,
  getDoc
} from "firebase/firestore";

export interface Socio {
  fotoUrl?: string;
  id?: string;
  // Campos originales
  nombre?: string;
  apellido?: string;
  guid?: string;
  ligaAsignada?: string;
  userUid?: string; // UID de Firebase para asociar al usuario
  puntosTotales?: number;

  // Todos los campos del Excel
  H?: string;
  user_login?: string;
  user_pass?: string;
  user_nicename?: string;
  user_email?: string;
  user_url?: string;
  user_registered?: string;
  user_activation_key?: string;
  user_status?: string;
  display_name?: string;
  GUID?: string;
  NOTAS?: string;
  NOMBRE_CORTO?: string;
  NOMBRE_SERVERS_VRS?: string;
  SOCIO?: string;
  Categoria?: string;
  PAIS?: string;
  EQUIPO?: string;
}

const sociosCollection = collection(db, "socios");

export const SocioServiceFirestore = {
  async create(socio: Omit<Socio, "id">) {
    const docRef = await addDoc(sociosCollection, socio);
    return { ...socio, id: docRef.id };
  },

  async getAll(): Promise<Socio[]> {
    //console.log('DEBUG - SocioServiceFirestore - Obteniendo todos los socios de Firestore...');
    try {
      const snapshot = await getDocs(sociosCollection);
      //console.log('DEBUG - SocioServiceFirestore - Número de documentos obtenidos:', snapshot.docs.length);
      
      const socios = snapshot.docs.map(doc => {
        const data = doc.data();
        const socio = { id: doc.id, ...data } as Socio;
        //console.log(`DEBUG - SocioServiceFirestore - Socio cargado: ${socio.display_name || socio.nombre}, Categoria: ${socio.Categoria}, ID: ${socio.id}`);
        return socio;
      });
      
      //console.log('DEBUG - SocioServiceFirestore - Total socios cargados:', socios.length);
      return socios;
    } catch (error) {
      //console.error('ERROR - SocioServiceFirestore - Error al obtener socios:', error);
      return [];
    }
  },

  async getById(id: string): Promise<Socio | null> {
    const docRef = doc(db, "socios", id);
    const docSnap = await getDoc(docRef);
    if (docSnap.exists()) {
      return { id: docSnap.id, ...docSnap.data() } as Socio;
    }
    return null;
  },

  async update(id: string, socioData: Partial<Socio>) {
    const docRef = doc(db, "socios", id);
    await updateDoc(docRef, socioData);
  },

  async delete(id: string) {
    const docRef = doc(db, "socios", id);
    await deleteDoc(docRef);
  }
};
